var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00EC97",
    d: "m15.617 6.613l-2.507 3.72c-.171.257.163.557.403.347l2.186-2.143c.064-.055.158-.017.158.077v6.708c0 .09-.12.128-.171.064L8.503 6.454A1.23 1.23 0 0 0 7.53 6C6.759 6 6 6.39 6 7.282v9.432a1.281 1.281 0 0 0 2.37.669l2.503-3.72c.171-.257-.159-.557-.399-.347l-2.173 2.186c-.064.055-.158.017-.158-.078v-6.69c0-.094.12-.128.171-.064l7.17 8.876c.24.296.6.454.973.454c.776 0 1.543-.386 1.543-1.281V7.286a1.286 1.286 0 0 0-2.383-.669z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNear);
export default __webpack_public_path__ + "static/media/near.a853bd442e4e529712c8ec6aa750d8a8.svg";
export { ForwardRef as ReactComponent };